import { FIELD_TYPES } from "../constants/fieldTypes";

function transform(value, type) {
  if (value != null) {
    if (type === FIELD_TYPES.boolean) {
      return [1, "1", "true", true].indexOf(value) >= 0;
    } else if (type === FIELD_TYPES.integer) {
      return parseInt(value, 10);
    } else if (type === FIELD_TYPES.string) {
      return value.toString();
    } else {
      return value;
    }
  } else {
    return value;
  }
}

const convertValues = (object, fieldTypes) => {
  if (typeof object !== "object") {
    return object;
  }

  let newObject = Object.assign({}, object);

  for (const key of Object.keys(object)) {
    if (Array.isArray(object[key]) && object[key].length) {
      newObject[key] = [];
      for (const value of object[key]) {
        newObject[key].push(transform(value, fieldTypes[key]));
      }
    } else if (!Array.isArray(object[key]) && object[key]) {
      newObject[key] = transform(object[key], fieldTypes[key]);
    }
  }
  return newObject;
};

export { convertValues };
